var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fixed"},[_c('header-name',[_vm._v("Training")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('training-comp',{attrs:{"trainings":_vm.trainings}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }